<template>
  <section class="otp-verification">
    <b-alert variant="danger" show v-if="messageErr">
      {{ messageErr }}
    </b-alert>

    <div class="otp-form mt-5">
      <h1>{{ $t("login.welcome") }}</h1>
      <h4>{{ $t("register.pleaseVerification") }}</h4>
      <h5>{{ $t("register.codeSent") }}</h5>

      <div class="block-header my-3">
        {{ $t("register.verificationAccount") }}
      </div>

      <form
        @submit.prevent="
          isRegisterOtp ? otpVerification() : otpChangingVerification()
        "
      >
        <b-form-group>
          <label for="otp-input">OTP</label>
          <span class="required">*</span>
          <b-form-input id="otp-input" v-model="form.code" required />
        </b-form-group>
        <b-button type="submit" variant="danger" class="bg-main">
          <font-awesome-icon icon="fas fa-lock" />
          {{ $t("register.verification") }}
        </b-button>
      </form>

      <div class="my-3 resend" @click="resendCode" v-if="!resend">
        {{ $t("register.notArrive") }}
      </div>
    </div>
  </section>
</template>

<script>
import auth from "@/services/auth";

export default {
  data() {
    const query = this.$route.query;

    return {
      form: {
        code: "",
        uuid: query.uuid || this.buyerUserData.uuid,
        email: query.email || this.buyerUserData.email,
      },
      messageErr: "",
      isRegisterOtp: !query.type,
      resend: query.resend || null,
      smsAvailability: null,
    };
  },

  async mounted() {
    if (!this.userInfo) {
      this.$router.push("/");
    }

    try {
      if (this.isRegisterOtp) {
        await this.emailVerify();
      } else {
        await this.emailChangingVerify();
      }

      await this.checkSmsAvailability();
    } catch (error) {
      console.error("Verification error:", error);
    }
  },

  methods: {
    async emailVerify() {
      if (!this.$route.query.uuid) return;

      const payload = {
        uuid: this.form.uuid,
        email: this.form.email,
        code: this.$route.query.code,
      };

      try {
        const res = await auth.emailVerify(payload);
        this.handleVerificationSuccess(res.data);
      } catch (error) {
        console.error("Email verification failed:", error);
      }
    },

    async emailChangingVerify() {
      if (!this.$route.query.uuid) return;

      const payload = {
        uuid: this.form.uuid,
        email: this.form.email,
        code: this.$route.query.code,
      };

      try {
        const res = await auth.changeEmail(payload);
        this.sucessMsg(res.data.message);
        localStorage.removeItem("massege");
        this.clearAlertBox();
        this.redirectPostVerification();
      } catch (error) {
        console.error("Email change verification failed:", error);
      }
    },

    otpVerification() {
      auth
        .verificationMobile(this.form)
        .then(this.redirectPostVerification)
        .catch(this.handleError);
    },

    otpChangingVerification() {
      auth
        .otpChangingVerification(this.form)
        .then(this.redirectPostVerification)
        .catch(this.handleError);
    },

    resendCode() {
      auth
        .resendCodeMobile()
        .then((res) => {
          this.sucessMsg(res.data.message);
        })
        .catch((error) => {
          this.handleError(error);
          if (error?.response?.data?.code === 400 && !this.resend) {
            this.resendCodeAgain();
          }
        });
    },

    resendCodeAgain() {
      const payload = {
        mobile_number: this.buyerUserData.mobile_number,
        callback_url: `${this.mainDoamin}otp-verification`,
      };

      auth.resendCode(payload).then((res) => {
        if (res.status === 200) {
          const path = this.smsAvailability ? "/otp-verification" : "/";
          const query = this.smsAvailability ? { resend: true } : {};

          this.$router.push({ path, query }, () => {
            this.$router.go(0);
          });
        }
      });
    },

    async checkSmsAvailability() {
      const res = await auth.getSiteImages();
      const smsSetting = res.data.items.find(
        (item) => item.key === "sms_status"
      );

      if (smsSetting?.value === "1" || smsSetting?.value === 1) {
        localStorage.setItem("sms_status", "available");
        this.smsAvailability = true;
      } else {
        localStorage.setItem("sms_status", "notAvailable");
        localStorage.removeItem("message");
        this.smsAvailability = false;
      }
    },

    // async redirectPostVerification() {
    //   await this.$store.dispatch("getUserInfo");

    //   const rawUserInfo =
    //     localStorage.getItem("newUserInfo") ||
    //     localStorage.getItem("userInfo") ||
    //     "{}";
    //   const userInfo =
    //     localStorage.getItem("buyerUserData") ||
    //     JSON.parse(rawUserInfo).item ||
    //     {};
    //   const trialActive =
    //     userInfo.trial_end_date &&
    //     new Date(userInfo.trial_end_date) > new Date();
    //   const freeSubscription = userInfo.buyer_type_data?.free_subscription == 1;

    //   const route =
    //     trialActive || freeSubscription ? "/" : "/profile/subscripePlans";
    //   this.$router.push({ path: route }, () => {
    //     this.$router.go(0);
    //   });
    // },
    async redirectPostVerification() {
      await this.$store.dispatch("getUserInfo");

      const rawUserInfo =
        localStorage.getItem("newUserInfo") ||
        localStorage.getItem("userInfo") ||
        "{}";
      const userInfoFromRaw = JSON.parse(rawUserInfo).item || {};
      const userInfoFromBuyer = JSON.parse(
        localStorage.getItem("buyerUserData") || "{}"
      );

      // Merge user info (prioritizing buyer data)
      const userInfo = { ...userInfoFromRaw, ...userInfoFromBuyer };

      // Check if user is verified
      if (!userInfo.is_verified) {
        this.$router.push({ path: "/" }, () => {
          this.$router.go(0);
        });
        return;
      }

      const trialActive =
        userInfo.trial_end_date &&
        new Date(userInfo.trial_end_date) > new Date();
      const freeSubscription = userInfo.buyer_type_data?.free_subscription == 1;

      const route =
        trialActive || freeSubscription ? "/" : "/profile/subscripePlans";
      this.$router.push({ path: route }, () => {
        this.$router.go(0);
      });
    },

    handleVerificationSuccess(data) {
      this.sucessMsg(data.message);

      localStorage.setItem("userInfo", JSON.stringify(data.items));
      localStorage.setItem(
        "access_token",
        JSON.stringify(data.items.access_token)
      );
      localStorage.setItem("expires_in", JSON.stringify(data.items.expires_in));

      const user = data.items.item;
      if (!user.email_verified_at) {
        localStorage.setItem("massege", this.$t("register.openEmail"));
      } else if (!user.mobile_verified_at) {
        localStorage.setItem("massege", this.$t("register.otpVerify"));
      } else {
        localStorage.setItem("massege", "");
      }

      localStorage.removeItem("guest-id");
      this.clearAlertBox();
      this.redirectPostVerification();
    },

    clearAlertBox() {
      const alertBox = document.querySelector(".activeAccountMessage");
      if (alertBox) {
        alertBox.style.display = "none";
      }
    },

    handleError(error) {
      const err = error?.response?.data?.message || "Unknown error occurred.";
      this.messageErr = err;
    },
  },

  watch: {
    smsAvailability(newVal) {
      if (!newVal) {
        this.$router.push("/", () => this.$router.go(0));
      }
    },
  },

  metaInfo: {
    title: "otp verify page",
    titleTemplate: "%s",
    htmlAttrs: {
      lang: localStorage.getItem("lang"),
      amp: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.otp-verification {
  text-align: center;

  h1 {
    color: black;
  }

  .otp-form {
    .block-header {
      background: $main-color;
      display: inline-block;
      padding: 12px;
      color: white;
    }

    input {
      max-width: 50%;
      margin: auto;
    }

    .resend {
      cursor: pointer;
      transition: all 0.5s ease-in-out;

      &:hover {
        color: $main-color;
      }
    }
  }
}

.bg-main {
  background: $main-color !important;
  color: #fff !important;
}
</style>
